import { useTranslation } from 'react-i18next';
import Constants from 'style/constants';
import MonitoringFilter from 'shared/components/monitoring/monitoring-filter/monitoring-filter';
import { MonitoringType } from 'shared/components/monitoring/monitoring-type';

interface IProps {
  count: number;
  countColorOverride?: string;
  isSelected: boolean;
  onSelected: (selected: boolean) => void;
}

const BatteryCombined = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return (
    <MonitoringFilter
      {...props}
      text={t('filter.batteryCombined')}
      type={MonitoringType.BatteryCombined}
      countColor={props.count > 0 ? Constants.Colors.brightOrange : Constants.Colors.onSurface}
    />
  );
};

const DeviceMalfunction = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return (
    <MonitoringFilter
      {...props}
      text={t('filter.deviceMalfunction')}
      type={MonitoringType.DeviceMalfunction}
      countColor={props.count > 0 ? Constants.Colors.brightOrange : Constants.Colors.onSurface}
    />
  );
};

const Offline = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return <MonitoringFilter {...props} text={t('filter.offline')} type={MonitoringType.Offline} countColor={Constants.Colors.error} />;
};

const Online = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return <MonitoringFilter {...props} text={t('filter.online')} type={MonitoringType.Online} countColor={Constants.Colors.success} />;
};

const Outdated = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return <MonitoringFilter {...props} text={t('filter.outDated')} type={MonitoringType.OutDated} countColor={Constants.Colors.error} />;
};

const NotMonitored = (props: Readonly<IProps>) => {
  const { t } = useTranslation('monitoring');

  return (
    <MonitoringFilter
      {...props}
      text={t('filter.notMonitored')}
      type={MonitoringType.NotMonitored}
      countColor={Constants.Colors.onSurface}
    />
  );
};

const DeviceMonitoringFilter = {
  MonitoringFilter: MonitoringFilter,
  Offline: Offline,
  Online: Online,
  BatteryCombined: BatteryCombined,
  Outdated: Outdated,
  NotMonitored: NotMonitored,
  DeviceMalfunction: DeviceMalfunction,
};

export default DeviceMonitoringFilter;
